import { Base } from '@studiometa/js-toolkit';

/**
 * Submenu component
 */
export default class Submenu extends Base {
  static config = {
    name: 'Submenu',
    refs: ['btn', 'submenu'],
  };

  /**
   *
   */
  onBtnClick() {
    this.$el.classList.toggle('is-open');
    this.$refs.submenu.classList.toggle('hidden');
    this.$refs.submenu.classList.toggle('is-open');
  }
}
